import { render, staticRenderFns } from "./fccTratamentoColegiosBusca.vue?vue&type=template&id=b0e7e070"
import script from "./fccTratamentoColegiosBusca.vue?vue&type=script&lang=js"
export * from "./fccTratamentoColegiosBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports